/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* `httpResource` is still an experimental feature - NOT PRODUCTION READY
* Generated Angular service for FeatureResource
* Do not edit this file manually
*/
import { HttpContext, HttpContextToken, HttpHeaders, HttpParams, httpResource, HttpResourceOptions, HttpResourceRef, HttpResourceRequest } from "@angular/common/http";
import { inject, Injectable, Signal } from "@angular/core";
import { BASE_PATH_DEFAULT, CLIENT_CONTEXT_TOKEN_DEFAULT } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { GetFeatureByIdResponse, GetFeaturesResponse, GetFeatureSelectResponse } from "../models";

@Injectable({ providedIn: "root" })
export class FeatureResource {
    private readonly basePath: string = inject(BASE_PATH_DEFAULT);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_DEFAULT;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'default');
    }

    getFeatureById(id: Signal<number> | number, resourceOptions: HttpResourceOptions<GetFeatureByIdResponse, unknown> & { defaultValue: NoInfer<GetFeatureByIdResponse> }, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetFeatureByIdResponse>;
    getFeatureById(id: Signal<number> | number, resourceOptions?: HttpResourceOptions<GetFeatureByIdResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetFeatureByIdResponse | undefined>;
    getFeatureById(id: Signal<number> | number, resourceOptions?: HttpResourceOptions<GetFeatureByIdResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetFeatureByIdResponse | undefined> {
        return httpResource(() => {
            return {
                url: `${this.basePath}/Feature/${typeof id === 'function' ? id() : id}`,
                method: "GET",
                context: this.createContextWithClientId(requestOptions?.context),
                ...requestOptions
            }
        }, resourceOptions);
    }

    getFeatures(searchTerm: Signal<string | null | undefined> | string | null | undefined, resourceOptions: HttpResourceOptions<GetFeaturesResponse, unknown> & { defaultValue: NoInfer<GetFeaturesResponse> }, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetFeaturesResponse>;
    getFeatures(searchTerm?: Signal<string | null | undefined> | string | null, resourceOptions?: HttpResourceOptions<GetFeaturesResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetFeaturesResponse | undefined>;
    getFeatures(searchTerm?: Signal<string | null | undefined> | string | null, resourceOptions?: HttpResourceOptions<GetFeaturesResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetFeaturesResponse | undefined> {
        return httpResource(() => {
            let params = new HttpParams();
            const searchTermValue = typeof searchTerm === 'function' ? searchTerm() : searchTerm;
            if (searchTermValue != null) {
                params = HttpParamsBuilder.addToHttpParams(params, searchTermValue, 'searchTerm');
            }
            return {
                url: `${this.basePath}/Feature`,
                method: "GET",
                params,
                context: this.createContextWithClientId(requestOptions?.context),
                ...requestOptions
            }
        }, resourceOptions);
    }

    getFeatureSelect(resourceOptions: HttpResourceOptions<GetFeatureSelectResponse, unknown> & { defaultValue: NoInfer<GetFeatureSelectResponse> }, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetFeatureSelectResponse>;
    getFeatureSelect(resourceOptions?: HttpResourceOptions<GetFeatureSelectResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetFeatureSelectResponse | undefined>;
    getFeatureSelect(resourceOptions?: HttpResourceOptions<GetFeatureSelectResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetFeatureSelectResponse | undefined> {
        return httpResource(() => {
            return {
                url: `${this.basePath}/Feature/Select`,
                method: "GET",
                context: this.createContextWithClientId(requestOptions?.context),
                ...requestOptions
            }
        }, resourceOptions);
    }
}
